import Components from './../Component';

export default class FormFilter extends Components {
  constructor($) {
    super($);
    this.wait = false;
    this.data;
  }

  getQueryString() {
    var query_string = {};
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      // If first entry with this name
      if (typeof query_string[pair[0]] === "undefined") {
        query_string[pair[0]] = decodeURIComponent(pair[1]);
        // If second entry with this name
      } else if (typeof query_string[pair[0]] === "string") {
        var arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
        query_string[pair[0]] = arr;
        // If third or later entry with this name
      } else {
        query_string[pair[0]].push(decodeURIComponent(pair[1]));
      }
    }
    return query_string;
  }

  init(index, element) {
    this.$('.empty-message').hide();
    var qs = this.getQueryString();
    this.$(element).find('*[data-filter]').each(function (i, form_element) {

      this.$(form_element).on('change keyup click', function (e) {
        //if checkbox, check the general value from serialize form
        if (this.$(form_element).attr('type') == 'checkbox') {
          var checkboxes = document.getElementsByName(this.$(form_element).attr('name'));
          var values = [];
          for (var i = 0, n = checkboxes.length; i < n; i++) {
            if (checkboxes[i].checked) values.push(checkboxes[i].value)
          }
          this.filter(element, this.$(form_element).attr('data-filter'), values, this.$(form_element).attr('data-condition'));
        } else {
          this.filter(element, this.$(form_element).attr('data-filter'), this.$(form_element).val());
        }

      }.bind(this));

      if (qs[this.$(form_element).attr('name')]) {
        this.$(form_element).val(qs[this.$(form_element).attr('name')]);
        this.$(form_element).change();
      }

    }.bind(this));
  }

  filter(element, filter, query, condition = 'OR') {

    //console.log(filter);

    if (query != '') {
      this.$('.prefix').hide();
    } else {
      this.$('.prefix').show();
    }

    if (this.wait) {
      this.waitTimeout = setTimeout(function () {
        this.filter(element, filter, query);
      }, 200);
    }
    this.wait = true;
    clearTimeout(this.waitTimeout);
    var is_empty = true;
    this.$(this.$(element).attr('data-items')).each(function (index, item) {

      if (Array.isArray(query)) {
        if (query.length > 0) {
          this.$(item).hide();
        } else {
          this.$(item).show();
          is_empty = false;
        }

        var flag = 0;
        this.$(query).each(function (index, value) {
          if (this.$(item).text().toLowerCase().indexOf(value.toLowerCase()) > -1) {
            flag++;
          }
        }.bind(this));
        if (condition == 'OR') {
          if (flag > 0) {
            this.$(item).show();
            is_empty = false;
          }

        }
        if (condition == 'AND') {
          if (flag == query.length) {
            this.$(item).show();
            is_empty = false;
          }
        }
      } else {
        this.$(item).hide();
        if (this.$(item).text().toLowerCase().indexOf(query.toLowerCase()) > -1) {
          this.$(item).show();
          is_empty = false;
        }
      }

      if (is_empty) {
        this.$('.empty-message .search-term').html(query);
        this.$('.empty-message').show();
      } else {
        this.$('.empty-message').hide();
      }


    }.bind(this));
    setTimeout(function () {
      this.wait = false;
    }, 100);
  }

}